
import { computed, ComputedRef, defineComponent, Ref, ref, watch } from 'vue';

interface IOption {
  id: number;
  name: string;
}

export default defineComponent({
  name: 'TriggerableDropdown',
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: Number,
      required: false,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const localOptions: ComputedRef<IOption[]> = computed(() => props.options as IOption[]);
    const localValue: Ref<number | null> = ref(props.modelValue);
    const hasNoOptions: ComputedRef<boolean> = computed(() => localOptions.value.length === 0);

    watch(
      () => props.modelValue,
      () => {
        localValue.value = props.modelValue;
      }
    );

    watch(localOptions, () => {
      if (!localOptions.value.some((option: IOption) => option.id === localValue.value)) {
        localValue.value = null;
      }
    });

    watch(localValue, (newValue: number | null) => emit('update:modelValue', newValue));

    return {
      hasNoOptions,
      localOptions,
      localValue,
    };
  },
});
